import { useParams } from 'react-router-dom'

export const useCoworkerId = () => {
  const { coworkerId } = useParams()
  if (!coworkerId)
    throw new Error('Cannot find CoworkerID in the route - is this used under right route?')
  return coworkerId
}
